import { render, staticRenderFns } from "./ProcessoMovimentacoes.vue?vue&type=template&id=2558a9b8&scoped=true&"
import script from "./ProcessoMovimentacoes.vue?vue&type=script&lang=js&"
export * from "./ProcessoMovimentacoes.vue?vue&type=script&lang=js&"
import style0 from "./ProcessoMovimentacoes.vue?vue&type=style&index=0&id=2558a9b8&prod&scoped=true&lang=stylus&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2558a9b8",
  null
  
)

export default component.exports